import { Checkbox } from '@mui/material';
import { SkillUpdateInput } from '../../queries';
import { TeamMemberRow } from '../../entity';

type CheckboxCellProps = {
  checked: boolean;
  row: TeamMemberRow;
  allRows: TeamMemberRow[];
  onUpdate: (data: SkillUpdateInput) => void;
};

const StockAccessCheckboxCell = ({ checked, row, allRows, onUpdate }: CheckboxCellProps) => {
  const handleChange = () => {
    const fullRow = allRows.find(r => r.userId === row.userId);
    if (!fullRow) {
      return;
    }

    onUpdate({
      memberId: fullRow.userId.toString(),
      canAccessStocks: !checked,
      canAccessClients: fullRow.canAccessClients,
      canAccessVisits: fullRow.canAccessVisits,
    });
  };

  return (
    <Checkbox checked={checked} color={checked ? 'success' : 'default'} onChange={handleChange} />
  );
};
export default StockAccessCheckboxCell;
